import { RealTimeRecord } from './real-time';

/** Sensor codes meaning "no reading" (same as legacy RT UI). */
const INVALID_SENSOR_CODES = new Set([128, 129]);

/**
 * Decode raw temperature from a realtime record into °C.
 * Returns null when the sensor reports no valid value.
 */
export function decodeRealTimeRecordTemperatureCelsius(
  temperature: number | string | null | undefined
): number | null {
  if (temperature == null || temperature === '') {
    return null;
  }

  const raw = Number(temperature);
  if (!Number.isFinite(raw)) {
    return null;
  }

  const sensorCode = Math.round(raw / 256);
  if (INVALID_SENSOR_CODES.has(sensorCode)) {
    return null;
  }

  const signed = raw > 32768 ? raw - 65536 : raw;
  return signed / 16;
}

/** Human-readable temperature for RT lists (e.g. "12.5°C" or "--"). */
export function formatRealTimeRecordTemperatureDisplay(
  record: RealTimeRecord | null | undefined,
  options: { placeholder?: string; includeUnit?: boolean } = {}
): string {
  const placeholder = options.placeholder ?? '--';
  const includeUnit = options.includeUnit !== false;
  const celsius = decodeRealTimeRecordTemperatureCelsius(record?.temperature);

  if (celsius == null) {
    return placeholder;
  }

  const formatted = celsius.toFixed(1);
  return includeUnit ? `${formatted}°C` : formatted;
}